import { render, staticRenderFns } from "./MapImgFallback.vue?vue&type=template&id=bc984406&"
import script from "./MapImgFallback.vue?vue&type=script&lang=js&"
export * from "./MapImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc984406')) {
      api.createRecord('bc984406', component.options)
    } else {
      api.reload('bc984406', component.options)
    }
    module.hot.accept("./MapImgFallback.vue?vue&type=template&id=bc984406&", function () {
      api.rerender('bc984406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/MapImgFallback.vue"
export default component.exports